import { SqlCaptureSetting } from 'utils/sql-capture-setting-types';

export function createSqlCaptureSetting(): SqlCaptureSetting {
  let enabled = false;
  const listeners = new Set<() => void>();

  return {
    isEnabled: () => enabled,
    setEnabled: (next) => {
      if (next === enabled) return;
      enabled = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    }
  };
}

export const sqlCaptureSetting = createSqlCaptureSetting();
